import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Modal, Header, Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import TourClientFacingStatus from "~/constants/Tour/TourClientFacingStatus";
import Tour from "~/models/Tour";

@observer
class ModalTourNotAccessible extends Component {
  render() {
    const { showModal, closeModalCallback, clickedTour, t } = this.props;

    // No click on a Tour
    if (!clickedTour) {
      return null;
    }

    return (
      <Modal open={showModal}>
        {clickedTour.clientFacingStatus === TourClientFacingStatus.IN_PROCESS ? (
          <>
            <Header icon="exclamation circle" content={t("clientPanelMisc:tourNotReadyEdit")} />
            <Modal.Content>
              <p>{t("clientPanelMisc:tourCurrentlyInProcess")}</p>
            </Modal.Content>
          </>
        ) : null}
        {!clickedTour.customerHasUrbanimmersiveGroupSpecialPricing &&
        clickedTour.clientFacingStatus === TourClientFacingStatus.INACTIVE ? (
          <>
            <Header icon="exclamation circle" content={t("tourInactive")} />
            <Modal.Content>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <p>{t("clientPanelMisc:cannotViewDetailInactiveTours")}</p>
            </Modal.Content>
          </>
        ) : null}
        <Modal.Actions>
          <Button color="green" inverted onClick={() => closeModalCallback()}>
            <Icon name="play" /> {t("clientPanelMisc:returnToTours")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
ModalTourNotAccessible.propTypes = {
  clickedTour: PropTypes.instanceOf(Tour),
  showModal: PropTypes.bool.isRequired,
  closeModalCallback: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ModalTourNotAccessible);
